import { Injectable } from '@angular/core';

export type ToastType = 'info' | 'success' | 'warning' | 'error';

export interface Toast {
  id: number;
  message: string;
  type: ToastType;
}

/**
 * Lightweight, non-blocking toast notifications. Use this instead of native
 * alert() for transient messages — alerts steal focus and freeze the page
 * (they block the JS thread). A single <app-toast> host in AppComponent renders
 * whatever is pushed here.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  /** Live list the ToastComponent renders (newest last). */
  readonly toasts: Toast[] = [];
  private nextId = 1;

  /** Show a toast; auto-dismisses after durationMs (pass 0 to make it sticky). */
  show(message: string, type: ToastType = 'info', durationMs = 6000): void {
    const id = this.nextId++;
    this.toasts.push({ id, message, type });
    if (durationMs > 0) {
      setTimeout(() => this.dismiss(id), durationMs);
    }
  }

  dismiss(id: number): void {
    const i = this.toasts.findIndex(t => t.id === id);
    if (i > -1) this.toasts.splice(i, 1);
  }
}
